import {
  MENUS_REQUEST,
  MENUS_SUCCESS,
  MENUS_FAILURE,
  MENU_DEFAULT_SUCCESS,
  MENU_DETAIL_REQUEST,
  MENU_DETAIL_SUCCESS,
  MENU_DETAIL_FAILURE,
  MENU_MUTATION_PENDING,
  MENU_MUTATION_DONE,
} from '../actions/menus';

const initialState = {
  list: [],
  defaultMenuId: null,
  useMenuSchedule: false,
  detail: null,
  isReceiving: false,
  isUpdating: false,
  error: '',
};

function normalizeDefaultMenuId(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export default function menus(state = initialState, action) {
  switch (action.type) {
    case MENUS_REQUEST:
      return { ...state, isReceiving: true, error: '' };
    case MENUS_SUCCESS:
      return {
        ...state,
        isReceiving: false,
        list: action.payload.menus || [],
        defaultMenuId: normalizeDefaultMenuId(action.payload.defaultMenuId),
        useMenuSchedule: !!action.payload.useMenuSchedule,
        error: '',
      };
    case MENU_DEFAULT_SUCCESS:
      return {
        ...state,
        defaultMenuId: normalizeDefaultMenuId(action.payload.defaultMenuId),
        useMenuSchedule: !!action.payload.useMenuSchedule,
      };
    case MENUS_FAILURE:
      return { ...state, isReceiving: false, error: action.payload || 'Failed to load menus' };
    case MENU_DETAIL_REQUEST:
      return { ...state, isReceiving: true, error: '' };
    case MENU_DETAIL_SUCCESS:
      return { ...state, isReceiving: false, detail: action.payload.menu, error: '' };
    case MENU_DETAIL_FAILURE:
      return { ...state, isReceiving: false, error: action.payload || 'Failed to load menu' };
    case MENU_MUTATION_PENDING:
      return { ...state, isUpdating: true };
    case MENU_MUTATION_DONE:
      return { ...state, isUpdating: false };
    default:
      return state;
  }
}
